export default {
  from: 'da',
  select: 'Seleziona',
  deal: 'offerta',
  deals: 'offerte',
  total: 'totale',
  total_fr: '',
  pp: 'pp',
}
